<template>
  <dd-header-page
    header="E-mail"
    :bread-crumbs="instanceCrumbs"
    id="customer-email-index"
    :class="{loaded: !loading}"
  >
    <template #content>
      <div class="flex-col" style="min-height: calc(100vh - 300px); margin-bottom: -5px">
        <router-view></router-view>
      </div>
      <MatchModalComponent/>
    </template>
  </dd-header-page>
</template>

<script>
import AttachableApi from "~/api/attachable";
import CustomerUtils from "~/util/customer";
import ViewStateEnum from "../enums/ViewStateEnum";
import store from "../../../store";
import emailModule from "../store";
import {mapActions, mapGetters, mapState} from "vuex";
import MatchModalComponent from "../components/match/MatchModalComponent.vue";
import ClassByCategoryEnum from "~/enums/ClassByCategoryEnum";


export default {
  name: "CustomerEmailPageOverview.vue",
  components: {
    MatchModalComponent,
  },
  data(){
    return {
      instanceCrumbs: undefined
    };
  },
  async created(){
    if (!store.hasModule('email')) store.registerModule('email', emailModule);
    this.$store.commit("email/SET_IS_CUSTOMER_PAGE", true);

    setTimeout(() => {  // timeout for the main store to initialize with userId
      this.emailId ? this.initialiseStoreForCustomerByEmailId(this.emailId) : this.initialiseStoreForCustomer();
    }, 200);

    if (this.instanceClass && this.instanceId) await this.getBreadCrumbs();
  },
  methods:{
    ...mapActions('email', [
      'initialiseStoreForCustomerByEmailId',
      'initialiseStoreForCustomer',
    ]),
    async getBreadCrumbs(){
      const { data } = await AttachableApi.getByClass(this.instanceClass, this.instanceId);
      this.instanceCrumbs = [{ name: CustomerUtils.getCleanName(data), to: data.uri }];
    },
  },
  computed: {
    ...mapState('email', [
        'selectedEmails'
    ]),
    ...mapGetters('email', [
      "viewState",
      "loading",
    ]),
    firstSelectedEmail(){
      return this.selectedEmails ? this.selectedEmails[0] : undefined;
    },
    emailId(){
      return this.$route.params?.emailId;
    },
    customerId(){
      return this.$route.params?.customerId;
    },
    instanceClass(){
      return ClassByCategoryEnum[this.firstSelectedEmail?.attachable?.data?.attachable_category?.data?.attachable?.data?.parent_category] ||
             this.$route.params?.instanceClass ||
             'customer';
    },
    instanceId(){
      if ( this.firstSelectedEmail?.attachable?.data?.attachable_category?.data?.attachable?.data?.parent_id ){
        return this.firstSelectedEmail?.attachable?.data?.attachable_category?.data?.attachable?.data?.parent_id;
      }
      return this.$route.params?.instanceId || this.customerId;
    },
    ViewStateEnum() {
      return ViewStateEnum;
    },
  },
  watch: {
    instanceClass(){
      this.getBreadCrumbs();
    },
    instanceId(){
      this.getBreadCrumbs();
    },
  }
}
</script>
